var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.874C15.75 13.6751 15.671 13.4843 15.5303 13.3437C15.3897 13.203 15.1989 13.124 15 13.124H9C8.80109 13.124 8.61032 13.203 8.46967 13.3437C8.32902 13.4843 8.25 13.6751 8.25 13.874C8.25 14.0729 8.32902 14.2637 8.46967 14.4044C8.61032 14.545 8.80109 14.624 9 14.624H15C15.1989 14.624 15.3897 14.545 15.5303 14.4044C15.671 14.2637 15.75 14.0729 15.75 13.874ZM15.75 17.874C15.75 17.6751 15.671 17.4843 15.5303 17.3437C15.3897 17.203 15.1989 17.124 15 17.124H9C8.80109 17.124 8.61032 17.203 8.46967 17.3437C8.32902 17.4843 8.25 17.6751 8.25 17.874C8.25 18.0729 8.32902 18.2637 8.46967 18.4044C8.61032 18.545 8.80109 18.624 9 18.624H15C15.1989 18.624 15.3897 18.545 15.5303 18.4044C15.671 18.2637 15.75 18.0729 15.75 17.874Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.12402C6.27065 3.12402 5.57118 3.41375 5.05546 3.92948C4.53973 4.4452 4.25 5.14468 4.25 5.87402V19.874C4.25 20.6034 4.53973 21.3028 5.05546 21.8186C5.57118 22.3343 6.27065 22.624 7 22.624H17C17.7293 22.624 18.4288 22.3343 18.9445 21.8186C19.4603 21.3028 19.75 20.6034 19.75 19.874V8.84202C19.75 8.46102 19.626 8.09102 19.396 7.78702L16.398 3.81902C16.2349 3.60314 16.0239 3.42802 15.7817 3.30743C15.5395 3.18684 15.2726 3.12406 15.002 3.12402H7ZM5.75 5.87402C5.75 5.18402 6.31 4.62402 7 4.62402H14.25V9.02102C14.25 9.43502 14.586 9.77102 15 9.77102H18.25V19.874C18.25 20.564 17.69 21.124 17 21.124H7C6.31 21.124 5.75 20.564 5.75 19.874V5.87402Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc_icon.f3aac97ae759a721a319e63e449d9eea.svg";
export { ForwardRef as ReactComponent };